import {useEffect, useState} from 'react'
import useBookings from '../../hooks/useBookings'
import BookingFeeForm, {BookingFeeFormValues} from './BookingFeeForm'

const defaultValues: BookingFeeFormValues = {
  scope: 'category',
  category: '',
  practitioner: '',
  practitionerLabel: '',
  listingType: 'class',
  listing: '',
  listingLabel: '',
  value: 0,
  type: '',
  startDate: '',
  endDate: '',
  active: true,
  note: '',
}

const CreateNewBookingFee = () => {
  const [message, setMessage] = useState('')
  const [isLoading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState(false)
  const [categories, setCategories] = useState([])

  const {getCategories, addBookingFee} = useBookings()

  useEffect(() => {
    const init = async () => {
      try {
        const {data} = await getCategories()
        setCategories(data)
      } catch (e) {
        setError(true)
      }
    }
    init()
  }, [])

  const handleSubmit = async (values: BookingFeeFormValues) => {
    try {
      setError(false)
      setLoading(true)

      await addBookingFee({
        scope: values.scope,
        category: values.scope === 'category' ? values.category : undefined,
        practitioner: values.scope === 'practitioner' ? values.practitioner : undefined,
        listingType: values.scope === 'listing' ? values.listingType : undefined,
        listing: values.scope === 'listing' ? values.listing : undefined,
        value: values.value,
        type: values.type,
        startDate: values.startDate || null,
        endDate: values.endDate || null,
        active: values.active,
        note: values.note,
      })

      setMessage('Booking fee rule created successfully')
    } catch (error: any) {
      setError(true)
      setMessage(error.message)
    } finally {
      setLoading(false)
      setShowModal(true)
    }
  }

  return (
    <>
      <BookingFeeForm
        title='Create New Booking Fee Rule'
        categories={categories}
        initialValues={defaultValues}
        submitLabel='Submit'
        onSubmit={handleSubmit}
        isLoading={isLoading}
      />
      {showModal && (
        <MessageModal
          error={error}
          showModal={showModal}
          setShowModal={setShowModal}
          message={message}
        />
      )}
    </>
  )
}

//@ts-ignore
const MessageModal = ({showModal, setShowModal, message, error}) => {
  return (
    <>
      <div
        className='modal fade show d-block'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered mw-550px'>
          <div className='modal-content'>
            <div className='modal-body scroll-y'>
              <div className='modal-header'>
                <h5 className='modal-title fs-2'>{error ? 'Error' : 'Success'}</h5>
              </div>
              <div className='modal-body fs-3'>
                <p>{message}</p>
              </div>
              <div className='modal-footer'>
                <button
                  onClick={() => {
                    setShowModal(false)
                    if (!error) {
                      window.location.href = '/apps/booking-fees-management/booking-fees/1'
                    }
                  }}
                  type='button'
                  className='btn btn-primary'
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export default CreateNewBookingFee
